import { InjectionToken } from '@angular/core';
import { EPeriodOptions, IPeriod } from '../interfaces/time-periods.interface';

export const PERIOD_OPTIONS: IPeriod[] = [
  {
    displayName: 'Today',
    name: EPeriodOptions.today,
  },
  {
    displayName: 'Yesterday',
    name: EPeriodOptions.yesterday,
  },
  {
    displayName: 'Past 7 days',
    name: EPeriodOptions.past7days,
  },
  {
    displayName: 'Prior Week',
    name: EPeriodOptions.priorWeek,
  },
  {
    displayName: 'Past 30 days',
    name: EPeriodOptions.past30days,
  },
  {
    displayName: 'Month to Date',
    name: EPeriodOptions.monthToDate,
  },
  {
    displayName: 'Prior Month',
    name: EPeriodOptions.priorMonth,
  },
  {
    displayName: 'Quarter to Date',
    name: EPeriodOptions.quarterToDate,
  },
  {
    displayName: 'Prior Quarter',
    name: EPeriodOptions.priorQuarter,
  },
  {
    displayName: 'Year to Date',
    name: EPeriodOptions.yearToDate,
  },
  {
    displayName: 'Prior Year',
    name: EPeriodOptions.priorYear,
  },
  {
    displayName: 'Custom',
    name: EPeriodOptions.custom,
  },
];

export const PERIOD_OPTIONS_TOKEN = new InjectionToken<IPeriod[]>('PERIOD_OPTIONS_TOKEN');
